export default {
    'The two passwords you entered did not match': '两次输入的密码不一致',
    'emailCodeSendTip': '我们已给您发送了验证码认邮件，请登录您的邮箱查收验证码，以完成您的密码设置。',
    'mobileCodeSendTip': '我们已给您发送了验证码，请去您的手机查收验证码，以完成您的密码设置。',
    'The verification code has been sent': '验证码已发送',
    'Please enter your correct email address': '请输入您的正确邮箱',
    'Please enter your email':'请输入您的邮箱',
    'Please enter your correct mobile': '请输入您的正确手机号',
    'Please enter your moblie':'请输入您的手机号',
    'Please enter your verification code':'请输入您的验证码',
    'select placeholder': '请选择您的',
    'Please upload your avatar': '请上传您的头像',
    'Please enter your name': '请输入您的姓名',
    'Please enter your company name': '请输入您的公司名称',
    'Please enter your position': '请输入您的职务',
    'Please enter your current password':'请输入您的当前密码',
    'Please enter your new password':'请输入您的新密码',
    'Please enter your new password again':'请再次输入您的新密码',
    'Please enter your password':'请输入您的密码',
    'The mobile phone number already exists, please enter again': '手机号码已存在请重新输入',
    'The mailbox already exists, please enter again': '此邮箱已存在，请重新输入',
    'current password':"当前密码",
    'Please enter your exhibitor code':'请输入您的展商码',
    newPassword: '新密码',
    inputAgain: '再次输入',
    newPasswordAgain: '请再次输入密码',
    'submit':"提交",
    'quesSubmit':"提交",
    'please click the "login/registration" button to register':'您还未注册请先点击“登录/注册”按钮进行注册',
    'Upload again':"重新上传",
    'del':"删除",
    'accountInfo':'注册信息',
    'Please enter your company':'请输入您的公司',
    'Please enter your department':'请输入您的部门',
    'Please enter your id card':'请输入您的身份证号码',
    'Please enter your correct ID number':'请输入您的正确的身份证号码',
    'Please select your country':'请选择您的国家',
    'Please select your province':'请选择您的省份',
    'Please select your city':'请选择您的城市',
    'Please select your address':'请输入您的地址',
    'Please select your fax':'请输入您的传真',
    'Please enter your correct fax':'请输入您的正确的传真',
    // 'You have registered, you can visit the online exhibition from June 18 to 24 by using this account':'您已成功注册"全国糖酒商品交易会",请于2021年4月21-27日登录参观。',
    'You have registered, you can visit the online exhibition from June 18 to 24 by using this account':'您已成功创建了您的账号，欢迎前往参观全国糖酒商品交易会。',
    
    'Confirm Registration': '登记成功',
    'sex':['男','女'],
    'Please select your title':'请选择您的称谓',
    'Top':'上一页',
    'Next':'下一页',
    'area code':'区号',
    'mobileRepeat':'手机号重复',
    'Questionnaire':'问卷',
    'Please choose the answer':'请选择答案',
    'Please enter the content':'请输入内容',
    'submit successfully':'提交成功',
    'Upload':'上传',
    // 'Pre-registration':'预登记',
    'Pre-registration':'问卷管理',
    'Complete Personal Information':'完善信息',
    // 'Successful pre-registration':'您的信息已成功提交，我们将在2小时内把审核结果发送到您的邮箱，请耐心等待。如有问题，请联系info@jinhanfair.com。（审核时间：GMT +8 08:30-17:30)',
    'Successful pre-registration': '您的登记已经成功，欢迎使用全国糖酒商品交易会的各种商贸功能，祝您观展愉快！',
    'Survey Management':'问卷管理'
}